import LegalText from "./LegalText";

export default LegalText;



// WEBPACK FOOTER //
// ./src/apps/payment/components/LegalText/index.js